import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import { SigninElementDataType } from '@/components/sections/builder/elements/body/signin/type';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { Input } from '@/components/ui/input';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export default function ElementSettingSignin({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const content = element.data as SigninElementDataType;

  return (
    <div>
      <h4 className='mb-4 mt-4 font-bold'>Section Body</h4>
      <p className='mb-2 text-xs'>Signin Title</p>
      <TextEditorMinimal
        onChange={(value) =>
          builder.setElementData(element.id, {
            headingLabel: value,
          })
        }
        value={content.headingLabel || 'Sign in'}
        placeholder='Signin Title'
        className='mb-2 w-full'
        output='html'
        editorProps={{
          attributes: {
            class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
          },
        }}
        editable
      />
      <p className='mb-2 text-xs'>Button Label</p>
      <Input
        name='buttonLabel'
        defaultValue={content.buttonLabel || 'Sign in'}
        value={content.buttonLabel}
        onChange={(e) => {
          builder.setElementData(element.id, {
            buttonLabel: e.target.value,
          });
        }}
      />
      <div className='mb-1 mt-4 font-bold md:mt-4'>Section Padding</div>
      <InputSlider
        label='Top padding'
        value={content.topPadding}
        onChange={(val) =>
          builder.setElementData(element.id, {
            topPadding: val,
          })
        }
      />
      <InputSlider
        label='Bottom padding'
        value={content.bottomPadding}
        onChange={(val) =>
          builder.setElementData(element.id, {
            bottomPadding: val,
          })
        }
      />
      <div className='mb-2 mt-4 font-bold'>Color scheme</div>
      <SchemeSetting
        value={content.colorScheme}
        onChange={(theme) => {
          builder.setElementData(element.id, {
            colorScheme: theme,
          });
        }}
      />
    </div>
  );
}
